import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ridango-page-content-wrapper',
  templateUrl: './page-content-wrapper.component.html',
  styleUrls: ['./page-content-wrapper.component.scss']
})
export class PageContentWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
